import React from 'react';

const Edit: React.FC<React.PropsWithChildren> = () => (
  <path d="M2.276 10.1666L9.03733 3.40531L8.09467 2.46264L1.33333 9.22398V10.1666H2.276ZM2.82867 11.5H0V8.67131L7.62333 1.04797C7.74835 0.922994 7.91789 0.852783 8.09467 0.852783C8.27144 0.852783 8.44098 0.922994 8.566 1.04797L10.452 2.93397C10.577 3.05899 10.6472 3.22853 10.6472 3.40531C10.6472 3.58208 10.577 3.75162 10.452 3.87664L2.82867 11.5ZM0 12.8333H12V14.1666H0V12.8333Z" />
);

export default Edit;
